import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BootstrapImageModalService {

  private _imgSrc = new BehaviorSubject<string>('');
  private _imgStamp = new BehaviorSubject<string>('');
  private _visible = new BehaviorSubject<boolean>(false);

  imgSrc$ = this._imgSrc.asObservable();
  imgStamp$ = this._imgStamp.asObservable();
  visible$ = this._visible.asObservable();

  open(imgSrc: string, imgStamp: string = '') {
    this._imgSrc.next(imgSrc);
    this._imgStamp.next(imgStamp);
    this._visible.next(true);
  }

  close() {
    this._visible.next(false);
    this._imgSrc.next('');
    this._imgStamp.next('');
  }
}
